<template>
  <div class="no-message">
    <i class="icon-no-message"></i>
    <strong>{{ translate("chat", "Нет сообщений", {}) }}</strong>
  </div>
</template>
<script>
;
export default {
  methods: {
    translate(source, message, params) {
      return translate(source, message, params);
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-no-message {
  display: inline-block;
  width: 86px;
  height: 86px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODYiIGhlaWdodD0iODYiIHZpZXdCb3g9IjAgMCA4NiA4NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTgxLjcgMTcuMkg3My4xVjU1LjlIMTcuMlY2NC41QzE3LjIgNjYuODY1IDE5LjEzNSA2OC44IDIxLjUgNjguOEg2OC44TDg2IDg2VjIxLjVDODYgMTkuMTM1IDg0LjA2NSAxNy4yIDgxLjcgMTcuMlpNNjQuNSA0M1Y0LjNDNjQuNSAxLjkzNSA2Mi41NjUgMCA2MC4yIDBINC4zQzEuOTM1IDAgMCAxLjkzNSAwIDQuM1Y2NC41TDE3LjIgNDcuM0g2MC4yQzYyLjU2NSA0Ny4zIDY0LjUgNDUuMzY1IDY0LjUgNDNaIiBmaWxsPSIjRjFGMkY0Ii8+Cjwvc3ZnPgo=");
}
.no-message {
  padding-top: 35px;
  padding-left: 50px;
  padding-right: 50px;
  text-align: center;
  strong {
    display: block;
    color: #161616;
  }
}
</style>
